module.exports = __webpack_public_path__ + "static/antd-space-spacing-d7ca24b698a0400ec1c95172a2fbcbc4.gif";